import React, { Component } from 'react';

import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';

import Dialog from '../../components/Dialog/Dialog';
import { ButtonDefault, ButtonPrimary } from '../../components/Button/Button';
import { CheckBox } from '../../components/Inputs/CheckBox/CheckBox';

export class DialogFinalizarInscricao extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            open: false,
            loading: false,
            termoInformacoesVeridicas: false,
            termoConsentimento: false,
            inscricaoFinalizada: false,
            precisaRealizarPagamento: false,
            dataFinalizacaoInscricao: null,
            pagamentoConfirmado: false,
        }
    }

    openModal = (dataFinalizacaoInscricao, precisaRealizarPagamento, pagamentoConfirmado) => {
        this.setState({
            open: true,
            loading: false,
            termoInformacoesVeridicas: dataFinalizacaoInscricao != null,
            termoConsentimento: dataFinalizacaoInscricao != null,
            inscricaoFinalizada: dataFinalizacaoInscricao != null,
            precisaRealizarPagamento: precisaRealizarPagamento,
            dataFinalizacaoInscricao: dataFinalizacaoInscricao,
            pagamentoConfirmado: pagamentoConfirmado,
        });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    handleCheckboxChange = (e) => {
        this.setState({ [e.target.name]: e.target.checked });
    }

    handleConfirm = () => {
        const { termoInformacoesVeridicas, termoConsentimento, precisaRealizarPagamento } = this.state;
        
        if (termoInformacoesVeridicas && (!precisaRealizarPagamento || termoConsentimento)) {
            this.setState({ loading: true });
            this.props.handleConfirm();
        }
    }

    render() {
        const { open, loading, termoInformacoesVeridicas, termoConsentimento, precisaRealizarPagamento, inscricaoFinalizada, dataFinalizacaoInscricao, pagamentoConfirmado } = this.state;

        return (
            <Dialog
                openDialog={open}
                title="Finalizar Inscrição"
                closeDialog={this.handleClose}
                actions={
                    <>
                        <ButtonPrimary
                            onClick={this.handleConfirm}
                            startIcon={<CheckOutlinedIcon />}
                            style={{ margin: 4 }}
                            name="Confirmar Inscrição"
                            loading={loading}
                            disabled={!termoInformacoesVeridicas || (precisaRealizarPagamento && !termoConsentimento) || inscricaoFinalizada || pagamentoConfirmado}
                        />
                        <ButtonDefault
                            onClick={this.handleClose}
                            startIcon={<ClearOutlinedIcon />}
                            style={{ margin: 4 }}
                            name="Fechar"
                        />
                    </>
                }
                fullWidth={true}
                maxWidth={"md"}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="body1" gutterBottom>
                            Para finalizar sua inscrição, por favor confirme os termos abaixo:
                        </Typography>
                    </Grid>
                    
                    <Grid item xs={12}>
                        { precisaRealizarPagamento ?
                            ( !inscricaoFinalizada ?
                                <Alert severity="warning">
                                    <>O Comprovante de Inscrição só estará disponível após a <b>Finalização da Inscrição</b>, e a <b>Confirmação do Pagamento</b>.</>
                                </Alert>
                            : !pagamentoConfirmado ?
                                <Alert severity="warning">
                                    <>Você já iniciou a confirmação de sua inscrição em <b>{dataFinalizacaoInscricao}</b>, e agora é necessário a <b>Realização do Pagamento</b> para finalizá-la.</>
                                </Alert>
                            :
                                <Alert severity="success">
                                    <>Você já finalizou a sua inscrição em <b>{dataFinalizacaoInscricao}</b>.</>
                                </Alert>
                            )
                        :
                            ( !inscricaoFinalizada ?
                                <Alert severity="info">
                                    <>O Comprovante de Inscrição só estará disponível após a <b>Finalização da Inscrição</b>.</>
                                </Alert>
                            :
                                <Alert severity="success">
                                    <>Você já finalizou a sua inscrição em <b>{dataFinalizacaoInscricao}</b>.</>
                                </Alert>
                            )
                        }
                    </Grid>
                    
                    <Grid item xs={12}>
                        <CheckBox
                            name="termoInformacoesVeridicas"
                            checked={termoInformacoesVeridicas}
                            onChange={this.handleCheckboxChange}
                            disabled={inscricaoFinalizada}
                            label={`Declaro que todas as informações prestadas são verdadeiras e estou ciente das regras de participação descritas no regulamento.`}
                        />
                    </Grid>
                    { precisaRealizarPagamento &&
                        <Grid item xs={12}>
                            <CheckBox
                                name="termoConsentimento"
                                checked={termoConsentimento}
                                onChange={this.handleCheckboxChange}
                                disabled={inscricaoFinalizada}
                                label={`Estou ciente de que a inscrição só será validada após a confirmação do pagamento da inscrição.`}
                            />
                        </Grid>
                    }
                </Grid>
            </Dialog>
        )
    }
}

export default DialogFinalizarInscricao;
